import { Button, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { FIELD_TYPES, type FieldType } from '../constants';
import type { FormTypeValue } from '../types';
import { canUseFileField } from '../utils/fields';
import { FIELD_ICONS } from './fieldMeta';

const { Text } = Typography;

interface FieldPaletteProps {
  formType: FormTypeValue;
  onAdd: (type: FieldType) => void;
  disabled?: boolean;
}

/** Sol palet — 8 alan tipi. `file` yalnız Career formunda etkin (BE kısıtı). */
export function FieldPalette({ formType, onAdd, disabled }: FieldPaletteProps) {
  const { t } = useTranslation('forms');
  const td = t as unknown as (key: string) => string;
  return (
    <div>
      <Text strong>{t('builder.palette')}</Text>
      <div style={{ fontSize: 12, color: 'var(--ds-text-tertiary)', marginBottom: 10 }}>
        {t('builder.paletteHint')}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {FIELD_TYPES.map((type) => {
          const fileDisabled = type === 'file' && !canUseFileField(formType);
          return (
            <Tooltip key={type} title={fileDisabled ? t('builder.fileCareerOnly') : undefined}>
              <Button
                block
                icon={FIELD_ICONS[type]}
                disabled={disabled || fileDisabled}
                onClick={() => onAdd(type)}
                style={{ justifyContent: 'flex-start', textAlign: 'left' }}
                data-testid={`field-palette-${type}`}
              >
                {td(`builder.fieldType.${type}`)}
              </Button>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}
